module.exports = __webpack_public_path__ + "img/serve_06@2x.3ed0d2fb.png";